<template>
    <div
        v-if="showAddDialog"
        class="dialog-mask">
        <div class="add-user-area">
            <div class="add-user-title">
                添加识别系统
            </div>
            <a-input-group size="large">
                <div class="input-line">
                    <div class="input-label">
                        姓名
                    </div>
                    <a-input
                        v-model="displayName"
                        placeholder="请输入姓名 (必填)" />
                </div>
                <div class="input-line">
                    <div class="input-label">
                        登录账号
                    </div>
                    <a-input
                        v-model="loginName"
                        placeholder="请输入手机号 (必填)" />
                </div>
                <div class="input-line">
                    <div class="input-label">
                        登录密码
                    </div>
                    <a-input
                        v-model="loginPassword"
                        type="password"
                        autocomplete="new-password"
                        placeholder="请输入登录密码（必填)" />
                </div>

                <div class="input-type-line">
                    <div class="input-type-label">
                        类型
                    </div>
                    <a-radio-group @change="typeChange" v-model="type">
                        <a-radio-button value="27">短识别账号</a-radio-button>
                        <a-radio-button value="28">测验账号</a-radio-button>
                        <a-radio-button value="29">复核账号</a-radio-button>
                    </a-radio-group>
                </div>
            </a-input-group>
            <div
                class="message"
                v-if="showError">
                {{ showMessage }}
            </div>
            <div class="submit-button-area">
                <a-button
                    v-on:click="addConfirm"
                    class="submit-button"
                    size="large">
                    创建
                </a-button>
                <a-button
                    v-on:click="addConfirmAndContinue"
                    class="submit-button"
                    size="large"
                    type="primary">
                    创建并继续
                </a-button>
            </div>
            <a-icon
                v-on:click="addCancel"
                class="close-button"
                type="close" />
        </div>
    </div>
</template>
<script>
 import Vue from 'vue';

 import { isEmptyOrWhitespace } from "../util/utils.js"
 import message from "ant-design-vue/lib/message";

 import InputGroup from "ant-design-vue/lib/input/Group";
 import Input from "ant-design-vue/lib/input/Input";
 import Radio from "ant-design-vue/lib/radio/Radio";
 import RadioGroup from "ant-design-vue/lib/radio/Group";
 import RadioButton from "ant-design-vue/lib/radio/RadioButton";

 Vue.component(InputGroup.name, InputGroup);
 Vue.component(Input.name, Input);
 Vue.component(RadioGroup.name, RadioGroup);
 Vue.component(RadioButton.name, RadioButton);
 Vue.component(Radio.name, Radio);

 export default {
     name: 'AddReviewerDialog',
     data() {
         return {
             showAddDialog: false,
             showError: false,
             addUserError: false,
             showMessage: "",
             displayName: "",
             loginName: "",
             loginPassword: "",
             type: "27"
         }
     },
     components: {
     },
     props: {
     },
     computed: {
     },
     methods: {
         show() {
             this.init()
             this.showAddDialog = true
         },
         init() {
             this.showError = false
             this.showMessage = ""
             this.displayName = ""
             this.loginName = ""
             this.loginPassword = ""
         },
         addCancel() {
             this.showAddDialog = false
         },
         addConfirm() {
             if (this.confirmInput()) {
                 var that = this
                 this.addUser(
                     function() {
                         that.showAddDialog = false

                         message.success("用户已经添加成功")
                     },
                     function(errorCode) {
                         that.showError = true
                         that.showMessage = "错误码：" + errorCode
                     }
                 )
             }
         },
         addConfirmAndContinue() {
             if (this.confirmInput()) {
                 var that = this

                 this.addUser(
                     function() {
                         that.init()
                         that.showAddDialog = true

                         message.success("用户已经添加成功")
                     },
                     function(errorCode) {
                         that.showError = true
                         that.showMessage = "错误码：" + errorCode
                     }
                 )
             }
         },
         confirmInput() {
             if (isEmptyOrWhitespace(this.loginName)) {
                 this.showError = true
                 this.showMessage = "请输入登录手机号"
                 return false
             } else if (isEmptyOrWhitespace(this.loginPassword)) {
                 this.showError = true
                 this.showMessage = "请输入登录密码"
                 return false
             } else if (isEmptyOrWhitespace(this.displayName)) {
                 this.showError = true
                 this.showMessage = "请输入姓名"
                 return false
             } else {
                 this.showError = false
                 this.showMessage = ""
                 return true
             }
         },
         addUser(successCallback, failedCallback) {
             this.addUserError = false

             var url = process.env.VUE_APP_API_SERVER + '/marker'
             var accessToken = localStorage.getItem('accessToken')
             var data = {
                 DisplayName: this.displayName,
                 Username: this.loginName,
                 Password: this.loginPassword,
                 Role: parseInt(this.type)
             }

             console.log(data)

             var that = this
             fetch(url, {
                 method: "POST",
                 body: JSON.stringify(data),
                 headers: new Headers({
                     'Content-Type': 'application/json',
                     'Access-Token': accessToken
                 })
             }).then(res => {
                 if (!res.ok) { throw res }
                 return res.json()
             }).catch(error => {
                 that.addUserError = true

                 failedCallback(error.status)
             }).then(response => {
                 console.log(response)

                 if (!that.addUserError) {
                     successCallback()
                 } else {
                     that.addUserError = false
                 }
             })
         },
         typeChange (e) {
             this.type = e.target.value
         },
     },
 }
</script>

<style scoped>
 .dialog-mask {
     position: absolute;
     top: 0;
     bottom: 0;
     left: 0;
     right: 0;
     background-color: rgba(0, 0, 0, 0.8);
     display: flex;
     flex-direction: column;
     align-items: center;
     justify-content: center;
     z-index: 1000;
 }
 .add-user-area {
     padding: 30px;
     background-color: #FFF;
     border: 1px solid #DDD;
     border-radius: 5px;
     box-shadow: 0px -5px 10px -10px #858484;
     width: 450px;
     height: 420px;
     position: absolute;
     display: flex;
     flex-direction: column;
     align-items: center;
 }
 .add-user-title {
     font-size: 24px;
     margin-bottom: 40px;
 }
 .submit-button-area {
     position: absolute;
     bottom: 30px;
     display: flex;
     flex-direction: row;
     align-items: center;
 }
 .submit-button {
     width: 150px;
     margin-left: 10px;
     margin-right: 10px;
 }
 .input-area {
     width: 100%;
 }
 .input-line {
     width: 100%;
     display: flex;
     flex-direction: row;
     align-items: center;
     margin-top: 10px;
 }
 .input-label {
     width: 120px;
     font-size: 16px;
     margin-right: 10px;
     text-align: start;
 }

 .input-type-line {
     width: 100%;
     display: flex;
     flex-direction: row;
     align-items: center;
     margin-top: 12px;
 }

 .input-type-label {
     width: 88px;
     font-size: 16px;
     margin-right: 10px;
     text-align: start;
 }

 .close-button {
     position: absolute;
     top: 10px;
     right: 10px;
     cursor: pointer;
     color: #AAA;
 }
 .close-button:hover {
     color: #666;
 }
 .message {
     margin-top: 10px;
     color: #D80E3B;
     font-size: 14px;
 }

 /* 禁止 Chrome 自动填充修改 input 样式 */
 input:-webkit-autofill,
 input:-webkit-autofill:hover,
 input:-webkit-autofill:focus,
 input:-webkit-autofill:active {
     -webkit-transition-delay: 99999s;
     -webkit-transition: color 99999s ease-out, background-color 99999s ease-out;
 }
</style>
